import * as React from 'react'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import {Visibility, ThumbUp, ThumbDown} from '@material-ui/icons'
import cn from 'classnames'
import * as styles from './styles.module.css'

const JetsoStatsDetail = ({className, type, stats}) => {
  const { t } = useTranslation()
  const getIcon = () => {
    if (type === 'views') {
      return (
        <Visibility />
      )
    }
    if (type === 'likes') {
      return (
        <ThumbUp />
      )
    }
    if (type === 'dislikes') {
      return (
        <ThumbDown />
      )
    }
    return (
      <></>
    )
  }
  const numberWithCommas = (x) => x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  const showStats = () => numberWithCommas(stats)
  const getText = () => t(`jetso.${type}`)
  
  return (
    <div className={cn(styles.statsRoot, className)}>
      {getIcon()}
      <p>{showStats()}</p>
      <p>{getText()}</p>
    </div>
  )
}

export default JetsoStatsDetail